import $ from 'jquery';
import JQueryView from '../../../../common/views/jqueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('#sb-site');

    this.setScrollFloatingFooter();
  }

  setScrollFloatingFooter() {
    $(window).on('scroll', () => {
      $('.js-floating').addClass('is-visible');
    });
  }
}
